import { FETCH_CARPOLICYTYPES_FAILURE, FETCH_CARPOLICYTYPES_REQUEST, FETCH_CARPOLICYTYPES_SUCCESS } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const carPolicyTypesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CARPOLICYTYPES_REQUEST:
            return {
                ...state,
            }
        case FETCH_CARPOLICYTYPES_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_CARPOLICYTYPES_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}